import { type Subscription, TierType } from '@getstep/proto/tier'
import { notNullish, nullish } from '@getstep/sdk/dist/util/Assert'
import { useEffectAsync } from '@lib/hooks/useEffectAsync'
import { PlaybookContext } from '@lib/store/playbook/context'
import { PlaybookStore } from '@lib/store/playbook/PlaybookStore'
import { useSession } from '@lib/store/useStores'
import { useContext, useState } from 'react'

export const usePlaybook = () => {
    const playbookValue = useContext(PlaybookContext)
    const [playbook] = useState(playbookValue ?? new PlaybookStore())
    return playbook
}

export const useTierCatalogSubscriptionInfo = () => {
    const { authorizedStore } = useSession()
    const [subscription, setSubscription] = useState<Subscription | undefined>(
        undefined,
    )
    useEffectAsync(async () => {
        if (nullish(subscription)) {
            const response = await authorizedStore?.tierStore?.getTierCatalog()
            if (notNullish(response)) {
                setSubscription(
                    response.find((tier) => tier.type === TierType.BLACK)
                        ?.subscription,
                )
            }
        }
    })

    return subscription
}
